import { MixtureTypeDetailDto, MixtureTypeEditDto } from './mixturetype';

export const mapMixtureTypeDetailToEdit = (
  dto: MixtureTypeDetailDto
): MixtureTypeEditDto => ({
  id: dto.id,
  name: dto.name,
  description: dto.description,
  candidateAmount: dto.candidateAmount,
  candidateSameGrade: dto.candidateSameGrade,
  candidateSameSpec: dto.candidateSameSpec,
  candidateLot: dto.candidateLot,
  candidateSpec: dto.candidateSpec,
  candidateSpecCustomer: dto.candidateSpecCustomer,
  completeCount: dto.completeCount,
  completeAmount: dto.completeAmount,
  completeSpec: dto.completeSpec,
  completeSpecCustomer: dto.completeSpecCustomer,
  runLotCreate: dto.runLotCreate,
  runLotComplete: dto.runLotComplete,
  candidateCount: dto.candidateCount,
  mixtureTypeParameters: dto.mixtureTypeParameters
});
